class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector('.g-footer--accordion');
    const mobileStickyBar = document.querySelector('.g-mobile-sticky-bar');

    if (mobileAccordion) {
      if (GkifyTheme.config.mqlMobile) {
        this.acc = new GkifyLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener('matchMobile', () => {
        this.acc = new GkifyLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener('matchMobile', () => {
        document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener('unmatchMobile', () => {
        document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define('g-footer', MFooter);
